import { format } from 'date-fns-tz';

export const dateToIsoStringAtTimezone = (
  date: Date,
  timezone: string
): string => {
  return format(date, 'yyyy-MM-dd HH:mm:ssXXX', { timeZone: timezone });
};
